const { default: CommonServices } = require("./common/common");

class ShlokaManagementService extends CommonServices {
  constructor() {
    super("/banners/shloka");
  }
}

const shlokaManagementService = new ShlokaManagementService();
export default shlokaManagementService;
